
(() => {
  const BUS = window.SA_BUS;
  if (!BUS) return;              
  const T = window.SA_TRACK || {};
  const emit = (name, params = {}, ctx = false) => BUS.emit(name, params, { ctx });

  const currency = () => window.themeStrings?.currency || T.currency || 'EUR';
  const money = (cents) => Math.round(Number(cents || 0)) / 100;
  const num = (v) => {
    const n = Number(String(v ?? '').replace(',', '.'));
    return Number.isFinite(n) ? n : 0;
  };
  const round2 = (n) => Math.round(n * 100) / 100;

  const clean = (o) => {
    Object.keys(o).forEach((k) => { if (o[k] === '' || o[k] == null) delete o[k]; });
    return o;
  };
  const text = (el) => (el?.textContent || '').replace(/\s+/g, ' ').trim();

  const normLine = (l) => ({
    key: l.key,
    product_id: l.product_id,
    variant_id: l.variant_id,
    url: l.url || '',
    image: l.image || l.featured_image?.url || '',
    title: l.product_title || l.title || '',
    variant_title: l.variant_title || '',
    price: Number(l.final_price ?? l.price ?? 0),   
    quantity: Number(l.quantity || 0),
    vendor: l.vendor || '',
    product_type: l.product_type || '',
  });

  const itemOfLine = (l, quantity) => clean({
    item_id: String(l.product_id ?? ''),
    item_name: l.title,
    item_variant: l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '',
    item_brand: l.vendor,
    item_category: l.product_type,
    price: money(l.price),
    quantity,
  });

  const itemOfJson = (i) => clean({
    item_id: String(i.item_id ?? ''),
    item_name: i.item_name,
    item_variant: i.item_variant,
    item_brand: i.item_brand,
    item_category: i.item_category,
    item_list_id: i.item_list_id,
    item_list_name: i.item_list_name,
    index: Number.isFinite(Number(i.index)) && i.index !== '' ? Number(i.index) : undefined,
    price: num(i.price),
    quantity: Number(i.quantity || 1),
  });

  let lines = new Map((T.cart?.items || []).map((l) => [l.key, normLine(l)]));
  let cartTotal = Number(T.cart?.total || 0);

  const cartItems = () => [...lines.values()].map((l) => itemOfLine(l, l.quantity));

  function onCartUpdate({ cart, source }) {
    if (!cart || !Array.isArray(cart.items)) return;
    const next = new Map(cart.items.map((l) => [l.key, normLine(l)]));
    const added = [];
    const removed = [];
    next.forEach((l, key) => {
      const was = lines.get(key);
      const d = l.quantity - (was ? was.quantity : 0);
      if (d > 0) added.push([l, d]);
      else if (d < 0) removed.push([l, -d]);
    });
    lines.forEach((l, key) => { if (!next.has(key)) removed.push([l, l.quantity]); });
    lines = next;
    cartTotal = Number(cart.total_price || 0);

    const paid = ([l]) => l.price > 0;
    const pack = (list) => ({
      currency: currency(),
      value: round2(list.reduce((s, [l, q]) => s + money(l.price) * q, 0)),
      items: list.map(([l, q]) => itemOfLine(l, q)),
    });
    const a = added.filter(paid);
    const r = removed.filter(paid);

    const spLines = (list) => list.map(([l, q]) => ({
      product_id: String(l.product_id ?? ''), variant_id: String(l.variant_id ?? ''), title: l.title,
      variant: l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '',
      price: money(l.price), quantity: q, url: l.url, image: l.image,
    }));
    if (a.length) emit('add_to_cart', { ...pack(a), source, lines: spLines(a) });
    if (r.length) emit('remove_from_cart', { ...pack(r), source });

    emit('cart_state', { item_count: cart.item_count || 0, attributes: cart.attributes || {} });

    if (source === 'promo-code' || source === 'promo-gift') promoDone(true);
  }

  let promo = null;          
  function promoStart(code) {
    code = String(code || '').trim();
    if (!code) return;
    promoStop();
    promo = { code, at: Date.now() };
    promo.timer = setTimeout(() => promoStop(), 15000);

    promo.mo = new MutationObserver(() => {
      if (!promo) return;
      const bad = [...document.querySelectorAll('[data-promo-msg]')]
        .some((m) => !m.hidden && !m.classList.contains('is-ok') && text(m));
      clearTimeout(promo.badTimer);
      if (bad) promo.badTimer = setTimeout(() => promoDone(false), 1500);
    });
    promo.mo.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'class'] });
  }
  function promoStop() {
    if (!promo) return;
    clearTimeout(promo.timer);
    clearTimeout(promo.badTimer);
    promo.mo?.disconnect();
    promo = null;
  }
  function promoDone(ok) {
    if (!promo) return;
    const coupon = promo.code;
    promoStop();
    emit('Use_promo_codes', { coupon, validation: ok ? 'accepted' : 'not accepted' });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-promo-apply]');
    if (!btn) return;
    const box = btn.closest('promo-gift, [data-promo-form]') || document;
    promoStart(box.querySelector('[data-promo-input]')?.value);
  }, true);
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const input = e.target.closest?.('[data-promo-input]');
    if (input) promoStart(input.value);
  }, true);

  const subscribe = () => {
    if (!window.PubSub || !window.EVENTS) return false;
    window.PubSub.subscribe(window.EVENTS.cartUpdate, onCartUpdate);
    window.PubSub.subscribe(window.EVENTS.drawerOpen, ({ id } = {}) => {
      if (id === 'cart-drawer' && lines.size) {
        emit('view_cart', { currency: currency(), value: money(cartTotal), items: cartItems() });
      }
    });
    return true;
  };
  if (!subscribe()) document.addEventListener('DOMContentLoaded', subscribe, { once: true });

  const hrefOf = (a) => a.getAttribute('href') || '';
  const urlOf = (a) => { try { return new URL(a.href, location.href); } catch (e) { return null; } };
  const isShare = (a, u) => a.classList.contains('share__link')
    || /\/(sharer|share)(\/|\.php|$)/i.test(u?.pathname || '');

  const SOCIAL = [
    ['instagram', /(^|\.)instagram\.com$/i, /^\/sistersaroma/i],
    ['facebook', /(^|\.)facebook\.com$/i, /^\/sistersaroma/i],
    ['tiktok', /(^|\.)tiktok\.com$/i, /^\/@sistersaroma/i],
    ['youtube', /(^|\.)youtube\.com$/i, /^\/(channel\/UCDWQm4XNfv3IhFFSEZSWFeg|@sistersaroma)/i],
  ];

  const BANNER = 'a.hero__link, .siteHeadBanner a[href], .hcl__banner a[href], .collection__banner a[href]';

  const XS_CART = '[data-cart-reco]';
  const XS_PRODUCT = '.product-reco, product-recommendations';
  const XS_TARGET = 'a[href], [data-card-add], [data-attention-add], button.pcard__add';

  function crossSellItem(target) {
    const card = target.closest('[data-product-card], .cardProductsAttentionItem');
    if (!card) return {};
    return clean({
      item_id: card.dataset.pid || card.dataset.productId || target.dataset.productId || '',
      item_name: text(card.querySelector('.pcard__title, .attentionName')),
    });
  }

  let pageList = null;       
  function listOf(card) {
    if (card.closest('[data-cart-reco]')) return { id: 'cart_cross_sell', name: 'Cart cross-sell' };
    if (card.closest('.product-reco, product-recommendations')) return { id: 'product_recommendations', name: 'Product recommendations' };
    if (document.body?.dataset.template?.startsWith('search')) return { id: 'search_results', name: 'Search results' };
    const sec = card.closest('.shopify-section');
    const id = (sec?.id || '').replace(/^shopify-section-(template--\d+__)?/, '');
    return { id, name: text(sec?.querySelector('h1, h2, h3')) || id };
  }
  function selectItem(a) {
    const card = a.closest('[data-product-card]');
    if (!card) return;

    const fromJson = card.closest('[data-cart-reco], .product-reco, product-recommendations') ? null
      : pageList?.items?.find((i) => String(i.item_id) === String(card.dataset.pid));
    const list = fromJson
      ? { id: String(pageList.item_list_id ?? ''), name: pageList.item_list_name || '' }
      : listOf(card);
    const scope = card.closest('.shopify-section, [data-cart-reco]') || document;
    const index = [...scope.querySelectorAll('[data-product-card]')].indexOf(card);
    const item = fromJson ? itemOfJson(fromJson) : clean({
      item_id: String(card.dataset.pid || ''),
      item_name: text(card.querySelector('.pcard__title')),
      price: money(card.dataset.price),
      quantity: 1,
    });
    item.item_list_id = item.item_list_id || list.id || undefined;
    item.item_list_name = item.item_list_name || list.name || undefined;
    if (item.index == null && index >= 0) item.index = index;
    emit('select_item', clean({
      item_list_id: list.id,
      item_list_name: list.name,
      items: [clean(item)],
    }));
  }

  document.addEventListener('click', (e) => {
    const target = e.target.closest(XS_TARGET);
    const a = e.target.closest('a[href]');

    if (target) {
      if (target.closest(XS_CART)) emit('Click_cross_sell_cart', crossSellItem(target));
      else if (target.closest(XS_PRODUCT) && document.body?.dataset.template?.startsWith('product')) {
        emit('Click_cross_sell_product_card', crossSellItem(target));
      }
    }
    if (!a) return;
    const href = hrefOf(a);
    const u = urlOf(a);

    if (/^tel:/i.test(href)) {
      const phone = href.slice(4).replace(/[^\d+]/g, '');
      emit('click_tel', { phone });
      if (a.closest('footer, .sa-foot')) emit('click_phone_down', { phone });
      return;
    }
    if (/^whatsapp:/i.test(href)) { emit('whatsapp_click', {}); return; }
    if (!u) return;
    const host = u.hostname.toLowerCase();

    if (host === 't.me' || host === 'telegram.me') {
      if (isShare(a, u)) return;
      emit('click_telegram', { bot: u.pathname.replace(/^\/+/, '').split(/[/?#]/)[0] });
      return;
    }
    if (host === 'wa.me' || host === 'api.whatsapp.com') { emit('whatsapp_click', {}); return; }

    for (const [name, h, p] of SOCIAL) {
      if (h.test(host) && p.test(u.pathname) && !isShare(a, u)) { emit(name, { link_url: u.href }); return; }
    }

    if (a.matches(BANNER)) {
      const slide = a.closest('.embla__slide, .swiper-slide');
      const slides = slide?.parentElement ? [...slide.parentElement.children] : [];
      emit('click_banner', clean({
        banner: a.getAttribute('aria-label') || text(a) || a.querySelector('img')?.alt
          || text(slide?.querySelector('.hero__heading, h2, h3')) || u.pathname,
        link_url: u.pathname + u.search,
        banner_position: slide ? slides.indexOf(slide) + 1 : undefined,
      }));
      return;
    }

    if (a.closest('[data-product-card]')) selectItem(a);
  }, true);

  const bindForms = () => document.querySelectorAll('#PartnersForm, .partners-page__form').forEach((f) => {
    if (f.dataset.saTracked) return;
    f.dataset.saTracked = '1';
    let last = 0;
    f.addEventListener('submit', (e) => {
      if (e.defaultPrevented || Date.now() - last < 10000) return;
      last = Date.now();
      emit('form_submit_partners', {});
    });
  });

  const marks = [25, 50, 75, 100];
  const fired = new Set();
  const onScroll = () => {
    const doc = document.documentElement;
    const max = doc.scrollHeight - window.innerHeight;
    const pct = max <= 0 ? 100 : Math.round((window.scrollY / max) * 100);
    for (const m of marks) {
      if (pct >= m && !fired.has(m)) {
        fired.add(m);
        emit(`scroll_${m}%`, { percent_scrolled: m });
      }
    }
    if (fired.size === marks.length) window.removeEventListener('scroll', onScroll);
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  const once = (key) => {
    try {
      const k = `sa_once:${key}:${location.pathname}${location.search}`;
      const t = Number(sessionStorage.getItem(k) || 0);
      if (Date.now() - t < 30 * 60000) return false;
      sessionStorage.setItem(k, String(Date.now()));
    } catch (e) {  }
    return true;
  };

  function pageContext() {
    const tpl = document.body?.dataset.template || '';

    const product = document.querySelector('[data-analytics-product]');
    if (product) {
      try {
        const d = JSON.parse(product.textContent || '{}');
        emit('view_item', {
          currency: d.currency || currency(),
          value: num(d.value),
          items: [itemOfJson({
            item_id: d.product_id, item_name: d.product_title, item_variant: d.variant_title,
            item_brand: d.vendor, item_category: d.product_type, item_list_id: d.list_id,
            item_list_name: d.list_name, price: d.price, quantity: d.quantity || 1,
          })],
        }, true);
      } catch (e) {  }
    }

    const collection = document.querySelector('[data-analytics-collection]');
    if (collection) {
      try {
        pageList = JSON.parse(collection.textContent || '{}');
        emit('view_item_list', {
          item_list_id: String(pageList.item_list_id ?? ''),
          item_list_name: pageList.item_list_name || '',
          items: (pageList.items || []).map(itemOfJson),
        }, true);
      } catch (e) { pageList = null; }
    }

    const q = new URLSearchParams(location.search).get('q');
    if (tpl.startsWith('search') && q && q.trim()) emit('search', { search_term: q.trim() }, true);

    if (tpl.startsWith('cart') && lines.size) {
      emit('view_cart', { currency: currency(), value: money(cartTotal), items: cartItems() }, true);
    }

    if (document.querySelector('.partners-page__form-ok') && once('opt_en')) emit('opt_en', {}, true);

    const params = new URLSearchParams(location.search);
    if (params.get('customer_posted') === 'true') {
      const hash = location.hash.replace('#', '');

      if (hash === 'SubscriptionForm' && once('popup_submit_discount')) emit('popup_submit_discount', {}, true);
      else if (hash === 'NewsletterForm' && once('newsletter_subscribe')) emit('newsletter_subscribe', {}, true);
    }

    setTimeout(onScroll, 800);   
  }

  const ready = () => { pageContext(); setTimeout(bindForms, 0); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
